<template lang="pug" functional>
  small.recaptcha-terms Este site é protegido pelo reCAPTCHA e a #[a.link(href="https://policies.google.com/privacy") Política de Privacidade] e os #[a.link(href="https://policies.google.com/terms") Termos de Serviço do Google] se aplicam
</template>

<script>
export default {
  name: 'RecaptchaTerms'
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables";

.recaptcha-terms {
  color: #595959;
  display: block;
  font-family: $rubik-font-family;
  line-height: 1.57;
  margin-bottom: 20px;
  padding-left: 16px;
  padding-right: 16px;

  a:link,
  a:visited {
    color: #0a4f85;
    text-decoration: underline;
  }
}
</style>
